var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXoxno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04326 4.2218C1.9292 4.10651 1.93197 3.92005 2.04941 3.80819L4.80133 1.18732C4.91522 1.07886 5.09483 1.08105 5.20604 1.19226L12.9308 8.91699C13.5789 9.56509 14.6227 9.58706 15.2975 8.9668L23.7957 1.15526C23.908 1.05212 24.0809 1.05354 24.1914 1.15852L26.7748 3.61272C26.892 3.72411 26.8954 3.90992 26.7823 4.02549L18.8767 12.1011C18.2312 12.7604 18.2252 13.8128 18.8629 14.4796L26.32 22.2756C26.4278 22.3884 26.427 22.5663 26.3182 22.678L23.9823 25.0771C23.8718 25.1906 23.6905 25.1943 23.5755 25.0853L15.5978 17.532C14.9305 16.9002 13.8831 16.9086 13.2261 17.5512L5.51047 25.0973C5.39902 25.2063 5.22132 25.2076 5.1083 25.1002L2.54178 22.662L2.05781 23.1715L2.54178 22.662C2.42503 22.5511 2.42111 22.3663 2.53306 22.2505L9.94475 14.5862C10.5911 13.9178 10.5851 12.8554 9.9311 12.1945L2.04326 4.2218Z",
    stroke: "#C75227",
    strokeWidth: 1.42049
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXoxno);
export default __webpack_public_path__ + "static/media/xoxno.34411e58e2ce4070364f94c120af1ef3.svg";
export { ForwardRef as ReactComponent };